import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet, HttpPost, HttpPostDownloadFile} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;

const listActivityLogs = (payload) => {

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPost(routes.LIST_ACTIVITY_LOGS, payload, subscriptionKey);
    return result;
}

const viewActivityLogs = (activityId) => {

    let query_params = {
        activity_id: activityId
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.VIEW_ACTIVITY_LOGS, query_params, subscriptionKey);
    return result;
}

const exportActivityLogs = (payload) =>{

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPostDownloadFile(routes.EXPORT_ACTIVITY_LOGS, payload, subscriptionKey);
    return result;
}

const ActivityLogsService = {
    listActivityLogs,
    viewActivityLogs,
    exportActivityLogs
}

export default ActivityLogsService
